<app-add-form
  data-testid="purchase-return-order-edit-form"
  #addForm
  [title]="'purchase_return_order.edit.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  [initialData]="currentFormData"
  [getFieldError]="getFieldError"
  (formAction)="onFormAction($event.action)"
  (formValueChanges)="onFormValueChange($event)"
  (tableAction)="onTableAction($event)"
></app-add-form>

<!-- Stock Selection Dialog (for adding items when no PO) -->
<app-rtv-stock-selection-dialog
  data-testid="purchase-return-order-edit-stock-selection-dialog"
  [visible]="showStockDialog()"
  (visibleChange)="onStockDialogVisibleChange($event)"
  [warehouseCode]="dialogWarehouseCode()"
  [existingSkuCodes]="existingSkuCodes()"
  [skuCodes]="vendorSkuCodes()"
  (confirm)="onStockDialogConfirm($event)"
></app-rtv-stock-selection-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-return-order-edit-toast"></p-toast>

